import { type QuestionsProps } from "@/features/questionnaire/types";
import { TextArea } from "@repo/skapa";

export const TextAreaQuestion = ({
  answer,
  onFreeTextAnswered,
}: QuestionsProps) => {
  return (
    <TextArea
      value={answer?.answerFreeText ?? undefined}
      onChange={(e) => {
        onFreeTextAnswered?.(e.target.value);
      }}
      label=""
    />
  );
};
